



























import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import _ from "lodash";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import moment from "moment";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import {
  InvestmentAccountDetails
} from "@/admin/types";
import {
  UserHsaAccountStatus
} from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { useInvestmentAccountRepointStore } from "@/admin/store/investmentAccountRepoint";

@Component({
  components: {
    GenericLoadingSpinner,
    Pagination
  }
})
export default class InvestmentRepointRequests extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  investmentAccountRepointStore = useInvestmentAccountRepointStore();

  @Prop()
  page: number;

  @Prop()
  routeToRepointRequests: (page: number) => Location;


  mounted (): void {
    this.fetchRequests();
  }

  investmentRepointRequestFields = [
    {
      key: "dateCreated",
      thClass: "text-left",
    },
    {
      key: "firstName",
      thClass: "text-left"
    },
    {
      key: "lastName",
      thClass: "text-left"
    },
    {
      key: "last4Ssn",
      thClass: "text-left"
    },
    {
      key: "status",
      thClass: "text-left"
    },
    {
      key: "statusDescription",
      thClass: "text-left"
    },
  ];

  fetchRequests (): void {
    this.investmentAccountRepointStore.getInvestmentRepointRequests(this.page);
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchRequests();
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToRepointRequests(toPage));
  }

  switchPageSize (): void {
    // on switching page size, reset to page 1
    this.investmentAccountRepointStore.setPageNumber(1);
    this.$router.push(this.routeToRepointRequests(1));
    this.fetchRequests();
  }

  getDateCreated (row) {
    return moment(row.dateCreated).format("MMM DD, YYYY");
}

  get records () {
    return this.investmentAccountRepointStore.getInvestmentRepointRequestsByPageNumber(this.page);
  }
}
